import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  ViewChild
} from '@angular/core';
import { Product } from '../../../../../core/models/product.model';
import { InventoryProduct } from '../../../../../core/models/inventory.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-find-product-by-number',
  templateUrl: './find-product-by-number.component.html',
  styleUrls: ['./find-product-by-number.component.scss']
})
export class FindProductByNumberComponent implements OnInit, AfterViewInit {
  productNumber: string;
  public noProductFound: boolean;
  @Input() products: InventoryProduct[] = [];
  @Output() foundProduct: EventEmitter<Product> = new EventEmitter<Product>();

  @ViewChild('productNumberInput', { static: false }) productNumberInput?: ElementRef<HTMLInputElement>;

  // Setting to show/hide the on-screen keyboard (persisted via localStorage)
  public showVirtualKeyboard: boolean = JSON.parse(localStorage.getItem('pos.showVirtualKeyboard') ?? 'true');

  constructor(
    @Optional() public dialogRef: MatDialogRef<FindProductByNumberComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // Autofocus the input when the component becomes visible
    setTimeout(() => this.productNumberInput?.nativeElement?.focus());
  }

  onInputKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onKeyboardInput('OK');
    }
  }

  @HostListener('window:keydown', ['$event'])
  onWindowKeydown(event: KeyboardEvent): void {
    const inputEl = this.productNumberInput?.nativeElement;
    const isFocused = !!inputEl && document.activeElement === inputEl;
    const target = event.target as HTMLElement | null;
    const isOtherInput =
      !!target && target !== inputEl && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || (target as any).isContentEditable);

    // If our input has focus, let native typing and ngModel handle updates.
    if (isFocused || isOtherInput) {
      return;
    }

    if (event.key === 'Enter') {
      this.onKeyboardInput('OK');
      event.preventDefault();
      return;
    }

    if (event.key === 'Backspace') {
      this.onKeyboardInput('←');
      event.preventDefault();
      return;
    }

    // if (/^[0-9]$/.test(event.key)) {
    this.onKeyboardInput(event.key);
    event.preventDefault();
    return;
    // }
  }

  onToggleKeyboard(): void {
    localStorage.setItem('pos.showVirtualKeyboard', JSON.stringify(this.showVirtualKeyboard));
  }

  onKeyboardInput(key: string): void {
    this.noProductFound = false;
    if (key === 'OK') {
      if (!this.productNumber) {
        return;
      }
      const foundProduct = this.products?.find(product => product.barCode === this.productNumber);
      if (foundProduct) {
        this.foundProduct.emit(foundProduct);
        this.noProductFound = false;
      } else {
        this.noProductFound = true;
      }
      return;
    }

    if (key === 'C') {
      this.noProductFound = false;
      this.productNumber = undefined;
      return;
    }
    if (key === '←') {
      this.noProductFound = false;
      if (this.productNumber === undefined) {
        return;
      }
      const value = this.productNumber.slice(0, -1);
      if (value === '') {
        this.noProductFound = false;
        this.productNumber = undefined;
        return;
      }
      this.productNumber = value;
      return;
    }
    this.productNumber = this.productNumber ? this.productNumber + key : key;
    // Handle key presses here (e.g., update a model or form control value)
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
